import { render } from "./RecipientsTable.vue?vue&type=template&id=2caf8882&scoped=true"
import script from "./RecipientsTable.vue?vue&type=script&lang=js"
export * from "./RecipientsTable.vue?vue&type=script&lang=js"

import "./RecipientsTable.vue?vue&type=style&index=0&id=2caf8882&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2caf8882"]])

export default __exports__